import { ITransaction } from 'api'
import { RetweetOutlined, QuestionOutlined, ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { TransactionType } from 'api/transactions/dtos'
import { BlockProps } from 'antd/lib/typography/Base'

export const getColorByFlow = (flowType: ITransaction['flowType']): BlockProps['type'] => {
	switch (flowType) {
		case 'IN':
			return 'success'
		case 'OUT':
			return 'danger'
		case 'EXCHANGE':
			return 'warning'
		case 'UNKNOWN':
		default:
			return 'secondary'
	}
}

export const getTransactionFlowIcon = (flowType: ITransaction['flowType']) => {
	switch (flowType) {
		case 'IN':
			return <ArrowDownOutlined />
		case 'OUT':
			return <ArrowUpOutlined />
		case 'EXCHANGE':
			return <RetweetOutlined />
		case 'UNKNOWN':
		default:
			return <QuestionOutlined />
	}
}

export const exportTransactionsToCSV = (transactions: ITransaction[]) => {
	const rows = [
		[
			'Type',
			'Date and Time',
			'In Currency',
			'In Amount',
			'In Currency Price Per Coin',
			'In Valuation Total',
			'Out Currency',
			'Out Amount',
			'Out Currency Price Per Coin',
			'Out Valuation Total',
			'Fee Currency',
			'Fee Amount',
			'Fee Price Per Coin',
			'Fee Valuation Total',
			'From Wallet Address',
			'To Wallet Address',
			'Blockchain Transaction Id',
			'Fork Primary Currency',
			'Original Acquisition Date',
			'Additional Costs',
			'Is Margin Loss/Profit In Value (Fiat)',
			'Margin Loss/Profit Value',
			'Group',
			'Note',
		],
	].concat(
		transactions.map(
			({
				type,
				date,
				in: _in,
				out,
				fee,
				blockchainId,
				forkBaseCurrency,
				acquisitionDate,
				additionalCosts,
				group,
				note,
				isMarginLossInValue,
				isMarginProfitInValue,
				marginLossValue,
				marginProfitValue,
			}) => [
				type,
				dayjs(date).format('D/M/YYYY HH:mm:ss'),
				_in?.currency || '',
				_in?.amount?.toString() || '',
				_in?.perCoin?.toString() || '',
				_in?.valuation?.toString() || '',
				out?.currency || '',
				out?.amount?.toString() || '',
				out?.perCoin?.toString() || '',
				out?.valuation?.toString() || '',
				fee?.currency || '',
				fee?.amount?.toString() || '',
				fee?.perCoin?.toString() || '',
				fee?.valuation?.toString() || '',
				out?.wallet?.address || '',
				_in?.wallet?.address || '',
				blockchainId || '',
				forkBaseCurrency || '',
				acquisitionDate ? dayjs(acquisitionDate).format('D/M/YYYY HH:mm:ss') : '',
				additionalCosts?.toString() || '',
				type === TransactionType.CURRENCY_MARGIN_LOSS || type === TransactionType.CURRENCY_MARGIN_PROFIT
					? isMarginLossInValue || isMarginProfitInValue
						? 'true'
						: 'false'
					: '',
				marginLossValue?.toString() || marginProfitValue?.toString() || '',
				group || '',
				note || '',
			]
		)
	)

	const csvContent = 'data:text/csv;charset=utf-8,' + rows.map(e => e.join(',')).join('\n')

	const encodedUri = encodeURI(csvContent)
	const link = document.createElement('a')
	link.setAttribute('href', encodedUri)
	link.setAttribute('download', `transactions_${Date.now()}.csv`)
	document.body.appendChild(link) // Required for FF

	link.click()
}
